export default __webpack_public_path__ + "assets/icons/sendMail.34d9dee9.svg";